angular.
module("dx.webapp.api").
factory("dxApiV1SAML", function apiV1SAMLService(
	$http,
	$window,

	DxSAMLIdentityProvider
) {
	"use strict";

	var baseUrl = "/api/v1/saml/";

	function identityProviderGet(listSource) {
		var queryParams = {};

		if (listSource) {
			queryParams.listSource = listSource;
		}

		var queryString = $window.jQuery.param(queryParams);
		var url = baseUrl + "identityproviders";

		if (queryString) {
			url += "?" + queryString;
		}

		return $http.get(url).then(function onResolve(response) {
			for (var i = 0; i < response.data.length; i++) {
				response.data[i] = new DxSAMLIdentityProvider(response.data[i]);
			}

			return response;
		});
	}

	return {
		identityProviders: {
			get: identityProviderGet,
		},
	};
});
